module.exports = __webpack_public_path__ + "static/media/Pencil.be543c6d.cur";